module.exports = __webpack_public_path__ + "static/media/6.Wet Grinder.0899cb41.jpg";